import * as React from "react";

import {Main} from "./components/MainLayout/Main";


const App = () => (
      <Main/>
);
export default App;
